// This file configures the initialization of Rollbar on the client.
// The config here will be used whenever a user loads a page in their browser.
// https://docs.rollbar.com/docs/nextjs
//
// FOUNDER-QA-FOLLOWUP-20260918-008/009 — built directly from `clientConfig` + `scrubConfig`
// (@/libs/rollbar) via `new Rollbar(...)` rather than `createClientInstance`, because
// `createClientInstance`'s `RollbarConfig` type (packages/rollbar/src/index.ts, out of this packet's
// allowed_paths) has no `scrubFields`/`scrubHeaders` fields to accept them.
import Rollbar from "@repo/rollbar";
import { clientConfig, scrubConfig } from "@/libs/rollbar";

const rollbarInstance = new Rollbar({ ...clientConfig, ...scrubConfig });

export default rollbarInstance;
